export default class PayerDetailRequest {
  constructor(customerNumber, companyCode, action, salesAreaData) {
    this.customer_number = customerNumber;
    this.company_code = companyCode;
    this.action = action;
    this.sales_area_data = salesAreaData;
  }
}
